import { classNames, wrapClick } from "utils";
import { LanguagePicker, List, Modal, ModalTabs, PDFRenderer, Show } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import config from "config";
import { useState } from "react";
import { useOffer } from "hooks/data/use-offers";
import { useFormik } from "formik";
import _ from "lodash";
import SupportingDocument from "pages/create-slip/components/supporting-document";
import { useOfferSupportingDocuments } from "hooks/data/use-supporting-documents";

const tabs = [
  {
    name: "Cover Note",
    href: "COVER_NOTE",
  },
  {
    name: "Debit Note",
    href: "DEBIT_NOTE",
  },
];

const placeITTabs = [
  {
    name: "PlaceIT Offer Slip",
    href: "PLACE_IT_PLACING_SLIP",
  },
  {
    name: "PlaceIT Supporting Documents",
    href: "SUPPORTING_DOCS",
  },
]

export default function ViewNotesContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [orderStatus, setOrderStatus] = useState("COVER_NOTE");
  const { loading, offer } = useOffer({
    offer_id: searchParams?.id || "",
  });
  const [offer_id, type, place_it_id] = searchParams?.id?.split(":") || [];
  const { documents, loading: fetchingOfferDocuments } = useOfferSupportingDocuments({ offerId: offer_id || "" });

  const form = useFormik({
    initialValues: {
      lang: "en"
    },
    onSubmit() {

    },
  })


  const urls = {
    "COVER_NOTE": `${config.asset.uri}generate_cover_slip/${btoa(
      JSON.stringify({
        offer_id: offer_id,
        period_from: offer?.offer_detail?.period_of_insurance_from,
        period_to: offer?.offer_detail?.period_of_insurance_to,
        lang: form.values.lang,
      })
    )}`,
    "DEBIT_NOTE": `${config.asset.uri}generate_debit_slip/${btoa(
      JSON.stringify({
        offer_id: offer_id,
        period_from: offer?.offer_detail?.period_of_insurance_from,
        period_to: offer?.offer_detail?.period_of_insurance_to,
        lang: form.values.lang,
      })
    )}`,
    "PLACE_IT_PLACING_SLIP": `${config.asset.placeItUri}/generate-broker-placing-slip/${place_it_id}`,
    "SUPPORTING_DOCS": `${config.asset.placeItUri}/generate-broker-supporting-docs/${place_it_id}`,
    INTERNAL_SUPPORTING_DOCUMENTS: `${config.asset.uri}generate-broker-supporting-docs/${offer_id}`,

  }

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading || fetchingOfferDocuments}
      hideActions
      size="6xl"
      title="Cover and Debit Note"
      description="View Cover and Debit Note"
    >
      <ModalTabs
        tabs={[...tabs, ...(type === "PLACEIT" ? placeITTabs : [{
          name: "Supporting Documents",
          href: "INTERNAL_SUPPORTING_DOCUMENTS",
        }])]}
        setOrderStatus={setOrderStatus}
        orderStatus={orderStatus}
      />
      <div className="p-3">
        {!["SUPPORTING_DOCS", "PLACE_IT_PLACING_SLIP"].includes(orderStatus) && (
          <div className="mb-3">
            <LanguagePicker id={"lang"} labelHidden {...form} />
          </div>
        )}
        <Show if={documents.length > 0 && orderStatus === "INTERNAL_SUPPORTING_DOCUMENTS"}>
          <List
            data={documents}
            renderItem={(doc) => (
              <SupportingDocument
                key={doc}
                documentName={doc}
                offerId={offer_id || ""}
              />
            )}
          />
        </Show>
        <PDFRenderer url={_.get(urls, orderStatus)} />
      </div>
    </Modal>
  );
}
